// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

import "./styles/themes.css"
import "./styles/prism-themes.css"
import { wrapPageElement as wrap } from "./root-wrapper"

export const wrapPageElement = wrap
